export default __webpack_public_path__ + "static/media/socialFb.be10caf5.svg";